import dayjs from 'dayjs';

export const parseDate = (date: string | null | undefined): dayjs.Dayjs | undefined => {
  if (!date) return undefined;

  // Handle "Present" case
  if (date.toLowerCase() === 'present') {
    return undefined;
  }

  // handle ISO String format (e.g., "2020-01-01")
  if (date.includes('T')) {
    return dayjs(date);
  }

  // Handle year only format (e.g., "2015")
  if (/^\d{4}$/.test(date)) {
    return dayjs(date).month(6).date(1); // Mid-year (July 1st)
  }

  // Handle year-month format (e.g., "2015-01")
  if (/^\d{4}-\d{2}$/.test(date)) {
    return dayjs(date).endOf('month');
  }

  // Handle full date format (e.g., "2015-01-01")
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return dayjs(date);
  }

  // If format doesn't match any of the above, return undefined
  return undefined;
};
